<template>
  <div class="feedBack_edit_dialog">
    <custom-dialog class="afterSaleRole-item-dialog" width="900px" :title="model.title" :visible="visible" v-on="$listeners">
      <div class="dialog-body">
        <el-form :model="form" size="small" ref="form" label-position="top">
          <div class="item-title">{{ $t('asm_feedBack_edit_dialog.ling_jian_xin_xi') }}</div>
          <div>
            <el-row>
              <el-col :span="24">
                <el-row :gutter="20">
                  <el-col :span="6">{{ $t('asm_feedBack_edit_dialog.ling_jian_bian_hao') }}：{{ form.partCode }}</el-col>
                  <el-col :span="6">{{ $t('asm_feedBack_edit_dialog.ling_jian_lei_bie') }}：{{ getDicValue('asm_part_class', form.partClass) }}</el-col>
                  <el-col :span="6">{{ $t('asm_feedBack_edit_dialog.ling_jian_lei_xing') }}：{{ getDicValue('asm_part_type', form.partType) }}</el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="6">{{ $t('asm_feedBack_edit_dialog.ling_jian_ming_cheng') }}：{{ form.partName }}</el-col>
                  <el-col :span="6">{{ $t('asm_feedBack_edit_dialog.ling_jianSN') }}：{{ form.partSn }}</el-col>
                  <el-col :span="6">{{ $t('asm_feedBack_edit_dialog.ling_jian_shu_liang') }}：{{ form.partName }}</el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="6">{{ $t('asm_feedBack_edit_dialog.ji_shen_hao') }}:{{ form.bodyNum }}</el-col>
                  <el-col :span="6">{{ $t('asm_feedBack_edit_dialog.chan_pin_xing_hao') }}：{{ form.productCode }}</el-col>
                  <el-col :span="6">{{ $t('asm_feedBack_edit_dialog.gong_dan_bian_hao') }}：{{ form.workOrderCode }}</el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
          <el-row>
            <el-col :span="8">
              <el-form-item :label="$t('asm_feedBack_edit_dialog.shi_fou_jin_shui')" prop="isSoak" :rules="rules.isSoak">
                <custom-select v-model="form.isSoak" code="isynergy_cloud_bool" :placeholder="$t('Common.com_please_select')" width="100%"></custom-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$t('asm_feedBack_edit_dialog.gu_zhang_miao_shu')" prop="feedBackDesc" :rules="rules.feedBackDesc">
                <el-input type="textarea" :rows="3" v-model="form.feedBackDesc" style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('asm_feedBack_edit_dialog.ling_jian_tu_pian')" prop="picList">
                <t-upload ref="feedBackItem" :limit="3" :bizId="form.feedBackId" bizType="asm.feedBack.icon" v-model="form.picList" :autoUpload="false"></t-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
        <el-button size="small" type="primary" @click="confirm(0)">{{ $t('Common.com_save') }}</el-button>
        <el-button size="small" type="primary" @click="confirm(1)">{{ $t('Common.com_submit') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import tUpload from '@/components/upload.vue';
import dialogMixins from '@/mixins/dialog_mixins';
// import languageInjectMixins from '@/mixins/language_inject_mixins';

export default {
  mixins: [dialogMixins],
  components: { tUpload },

  data() {
    return {
      ossConfig: {},
      item: {},
      // visible: false,
      fileList: [],
      form: {
        feedBackId: '',
        partId: '',
        partCode: '',
        partName: '',
        partClass: '',
        partType: '',
        partSpec: '',
        partUnit: '',
        replaceNum: '',
        isSoak: '',
        partSn: '',
        feedBackDesc: '',
        picList: [],
        isSubmit: 1,
        changeId: '',
      }
    };
  },
  computed: {
    rules() {
      return {
        partCode: [{ required: true, message: this.$t('asm_feedBack_edit_dialog.qtxljbh') }],
        partName: [{ required: true, message: this.$t('asm_feedBack_edit_dialog.qsrljmc') }],
        partClass: [{ required: true, message: this.$t('asm_feedBack_edit_dialog.qxzljlb') }],
        partType: [{ required: true, message: this.$t('asm_feedBack_edit_dialog.qxzljlx') }],
        partSpec: [{ required: true, message: this.$t('asm_feedBack_edit_dialog.qtxljgg') }],
        partUnit: [{ required: true, message: this.$t('asm_feedBack_edit_dialog.qing_xuan_ze_dan_wei') }],
        replaceNum: [{ required: true, message: this.$t('asm_feedBack_edit_dialog.qtxljsl') }],
        partSn: [{ required: true, message: this.$t('asm_feedBack_edit_dialog.qtxljSN') }],
        isSoak: [{ required: true, message: this.$t('asm_feedBack_edit_dialog.qxzsfjs') }],
        feedBackDesc: [
          { max: 200, message: this.$t('Common.com_rules_length_max', [200]), },
          { required: true, message: this.$t('asm_feedBack_edit_dialog.qtxgzms') },
        ],
      };
    },
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        // this.visible = true;
      });
      if (this.model.type === 'edit') {
        this.getDetail();
      }
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    getDetail: function () {
      this.$getJSON(apis.feedbackInfo, { feedBackId: this.model.data.feedBackId }).then((res) => {
        const data = res.data;
        this.$setFormatData(this.form, data);
      });
    },

    // 确认保存
    confirm: async function (isSubmit) {
      this.form.isSubmit = isSubmit;
      this.$refs.form.validate(async (valid) => {
        if (!valid) {
          return;
        }
        await this.$refs.feedBackItem.submit();

        if (this.model.type === 'edit') {
          this.saveUpdate(isSubmit);
        }
      });
    },
    // 保存编辑
    saveUpdate: function (isSubmit) {
      this.$postJSON(apis.feedbackApply, this.form).then((res) => {
        // 提交审批
        if (isSubmit) {
          this.form.changeId = res.data;
          this.$postJSON(`${apis.apsApproveApprovalApproveStart}/feed_back/${this.form.changeId}`, this.form, true).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('Common.com_handle_success'),
            });
            this.$emit('success');
          });
        } else {
          this.$message({
            message: this.$t('Common.com_edit_success'),
            type: 'success',
          });
          this.closeDialog();
          this.$emit('success', this.form);
        }
      });
    },
  },
};
</script>

<style lang="scss">
.feedBack_edit_dialog {
  .el-col {
    line-height: 34px;
  }
}
</style>
